import React from "react";

const ColumnFlex = (props) => {
    return <div className={`flex flex-col ${props.className || ""}`}>{props.children}</div>;
};

export default ColumnFlex;
